/* =================== produtos relacionados =================== */
jQuery(document).ready(function($){
  $('.carrosel-produtos').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 760,
      settings: {
        slidesToShow: 2
      }
    }
    ]
  });
});
